/* eslint-disable */
(function () {

    const loadGoogleRecaptchaJS = () => {
        var tag = document.createElement("script");
        tag.src = "https://www.google.com/recaptcha/api.js";
        tag.id = "recaptchajs"
        document.querySelector("#recaptchajs") ? document.querySelector("#recaptchajs").remove() : null;
        document.getElementsByTagName("head")[0].appendChild(tag);    
    }
    
    const loadingHtml = `
        <div class="loading-data">
                <div class="loading-data-spinner"></div>
        </div>
    `;
    
    const requiredHtml = () => {
        var tag = document.createElement("span");
        tag.innerText = " * Required";
        tag.classList.add("sq-form-required-field");
        return tag;        
    }
        
    const fetchForms = async(answer, result) => {
        const formContainer = result.querySelector(`.feedback__form`);
        const loadingSpinner = result.querySelector(`.loading-data`);
        
        // Retrieve the dataset values off the accordion-item
        const faqTitle = result.querySelector(".accordion-item__control").innerText.trim();
        const faqAssetId = result.dataset.assetid;
        const faqCategory = result.dataset.location !== '' ? result.dataset.category : 'Not provided';
        const faqSubcategory = result.dataset.location !== '' ? result.dataset.subcategory : 'Not provided';
        let faqLocation = '';
        
        // Determine location
        if (window.location.hostname.includes('energex')) {
            faqLocation = 'SEQ';
        } else if (window.location.hostname.includes('ergon')) {
            faqLocation = 'QLD';
        }

        loadingSpinner.classList.remove('hidden');
        var createFormHTML = "";
        
       // if(window.cachedFormHTML){
        //    createFormHTML = window.cachedFormHTML;
       // } else {
            const formURL = document.querySelector("#feedback-form-url").dataset.url;
            const getForm = await fetch(formURL)
            createFormHTML = await getForm.text()

            // Create a temporary div element to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = createFormHTML;

            // Create a temporary div element to parse the HTML
            const sanitizedForm = document.createElement('form');

            // Extract form attributes from the original HTML
            const originalForm = tempDiv.querySelector('form');
            if (originalForm) {
                for (const { name, value } of originalForm.attributes) {
                    sanitizedForm.setAttribute(name, value);
                }
            }

            // Iterate through the child nodes and sanitize them
            for (const child of tempDiv.childNodes) {
                if (child.nodeType === Node.ELEMENT_NODE) {
                    // Only allow specific tags and attributes
                    if (['input', 'textarea', 'div'].includes(child.tagName.toLowerCase())) {
                        const sanitizedChild = document.createElement(child.tagName);
                
                        // Copy whitelisted attributes
                        for (const { name, value } of child.attributes) {
                            if (['name', 'value', 'cols', 'rows', 'maxlength', 'class', 'for', 'id'].includes(name)) {
                                sanitizedChild.setAttribute(name, value);
                            }
                        }
                
                        sanitizedForm.appendChild(sanitizedChild);
                    }
                }
            }

           // window.cachedFormHTML = sanitizedForm.outerHTML;
           // var tmp = document.createElement("div");
           // tmp.appendChild(sanitizedForm);
          // window.cachedFormHTML = tmp.innerHTML;
       // }

        loadingSpinner.classList.add('hidden')
        formContainer.innerHTML = createFormHTML;
        loadGoogleRecaptchaJS();

        // Populate hidden fields
        formContainer.querySelector(".faq-input-title input").value = faqTitle;
        formContainer.querySelector(".faq-input-id input").value = faqAssetId;
        formContainer.querySelector(".faq-input-answer input").value = answer;
        formContainer.querySelector(".faq-input-location input").value = faqLocation;
        formContainer.querySelector(".faq-input-category input").value = faqCategory;
        formContainer.querySelector(".faq-input-subcategory input").value = faqSubcategory;

        if(answer === "No") {
            formContainer.querySelector(".faq-input-comment label").append(requiredHtml())
        }
    
        submitHandler(formContainer, answer);
    }
    
    const submitHandler = (formContainer, answer) => {
        formContainer.querySelector("form").addEventListener("submit", function(e){
            e.preventDefault();
            // Create Form data object, append submit button for matrix functionality
            var formData = new FormData(this);
            // Form validation
            if (!formData.get("g-recaptcha-response")) {
                // Prevent submit if recaptcha is not completed
                alert("Please complete the reCAPTCHA")
                return;
            } else if(answer === "No" && !formData.get(formContainer.querySelector(".faq-input-comment textarea").name) ){
                // Prevent submit if awnser is No, and a comment has not been provided.
                alert("Please provide a comment to help improve our website")
                return;
            }
            
            var formSubmitBtn = this.querySelector('input[type=submit]');
            formData.append(formSubmitBtn.name, formSubmitBtn.value);
            // set loading state
            if(formContainer.parentElement.querySelector(".feedback__head")){
                formContainer.parentElement.querySelector(".feedback__head").remove();    
            }
            formContainer.innerHTML = loadingHtml;
            
            // submit form, await response
            submitForm(formData, this.action).then(response => {
                formContainer.innerHTML = response;
                if(!response.includes("Thank you")){
                    // Re-enable form submit
                    loadGoogleRecaptchaJS();
                    submitHandler(formContainer);
                }
            });
        });
    }
    
    const submitForm = async (data, url) => {
        const submission = await fetch(url, {
            method: 'post',
            body: data,
        })
        const response = await submission.text();
        return response;
    };

    // Identify if the page has feedback-btns, init faq feedback forms
    const feedbackBtns = document.querySelectorAll(".feedback-btn");
    if(feedbackBtns){
        document.addEventListener("DOMContentLoaded", function(){
        
            feedbackBtns.forEach(btn => {
                btn.addEventListener("click", () => {
                    // Remove active class from buttons,then add to clicked btn
                    var btnParent = btn.parentElement.children;
                    for (let button of btnParent) {
                        button.classList.remove("active")
                    }
                    btn.classList.add("active")

                    fetchForms(
                        btn.innerText.trim(),
                        btn.closest(".accordion-item")
                    );
                });
            }); 
        });
    }

})();
